import 'jquery-ui/ui/widgets/autocomplete';
import EventDispatcher from "events";
import find from "lodash/find";

export default class SearchBar extends EventDispatcher {

    constructor(selector) {
        super();

        this.searchBar = $(selector ? selector : '.js_header_search-bar');
        this.searchInput = $('.js_header_search-input')
        this.searchIcon = $('.js_header_search-icon');
        this.points = [];

        if (this.searchBar.length === 0) {
            throw new Error('Не найдена строка поиска');
        }

        this.init();
    }

    init() {

        let _this = this;

        this.searchInput.keypress(function (e) {
            if (e.which == 13) {
                _this.searchIcon.click();
            }
        });

        this.searchInput.autocomplete({
            minLength: 0,
            source: function(request, response) {
                $.ajax({
                    method: 'GET',
                    url: '/ajax/search-map',
                    data: {
                        term: request['term']
                    },
                    success: (r) => {
                        response(r);
                    }
                });
            },
            appendTo: '.js_header_search-bar',
            blankItem: true,
            select: (event, ui) => {
                _this.searchInput.val(ui.item.label);
                let id = ui.item.id.split("_");
                switch(id[0]) {
                    case 'category':
                        window.location = '/map?category=' + ui.item.slug + '&search=' + ui.item.label;
                        break;
                    case 'point':
                        window.location = '/map?default_point_id=' + id[1] + '&search=' + ui.item.label;
                        break;
                    case 'supplier':
                        this.changePointsContent({
                            'supplier': id[1]
                        });
                        break;
                }

            _this.searchIcon.addClass('search__icon_clear');

                return false;
            }
        }).autocomplete('instance')._renderItem = function(ul, item) {
            return $("<li id='"+ item.id +"' class='ui-menu-item'>")
                .append(
                    (item.color ? '<div class="ui-menu-item-color" style="background-color: '+
                        item.color +
                        '"></div>' : '')
                    + item.label + (item.add && item.add.length !== 0 ? " <small style='color: grey; font-size: 0.8rem'>"+ item.add +"</small>" : '')
                    + "</div>")
                .appendTo(ul);
        };

        this.searchIcon.click(() => {
            if (_this.searchIcon.hasClass('search__icon_clear')) {
                _this.searchInput.val('');
                _this.searchIcon.removeClass('search__icon_clear');
                this.changePointsContent('')
            }
        });
    }
}


// WEBPACK FOOTER //
// app/widgets/assets/search-bar/widget.js